import { Component, Host, h, Prop, Element, State } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

declare var ScrollMagic: any;

@Component({
  tag: 'super-scroll',
  styleUrl: 'super-scroll.css',
  shadow: false,
})
export class SuperScroll {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The description
   */
  @Prop() mainDescription: string;

  /**
   * Cards Data
   */
  @Prop() cardsData: string;

  /**
   * Buttons Data
   */
  @Prop() buttonsData: string;

  /**
   * Logos Data
   */
  @Prop() logosData: string;

  /**
   * Logo Row Title
   */
  @Prop() logoRowTitle: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  @State() activeSlideIndex: number = 0;
  private slideInterval: any;

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }
  componentDidLoad() {
    this.initializeScrollMagic();
  }

  disconnectedCallback() {
    //nothing for now
    clearInterval(this.slideInterval);
  }

  preventDefaultScroll(isEnabled) {
    if (isEnabled) {
      document.body.style.overflow = 'hidden'; // Lock scrolling by hiding overflow
    } else {
      document.body.style.overflow = ''; // Re-enable scrolling
    }
  }
  
  cleanupScroll(handleScrollFunction) {
    window.removeEventListener('wheel', handleScrollFunction);
    this.preventDefaultScroll(false);
  }
  

  toggleFade(element) {
    if (element) {
      // Check if the element currently has the 'fade-out-slide' class
      if (element.classList.contains('fade-out-slide')) {
        // If it does, remove it to initiate fade-in
        element.classList.remove('fade-out-slide');
      } else {
        // If it doesn't, add it to initiate fade-out
        element.classList.add('fade-out-slide');
      }
    }
  }
  
  startSlideAutomation(tabs) {
    const intervalDuration = 6000; // Minimum 4 seconds
  
    this.slideInterval = setInterval(() => {
      this.activeSlideIndex = (this.activeSlideIndex + 1) % tabs.length;
      this.updateSlideContent(tabs[this.activeSlideIndex]);
    }, intervalDuration);
  }

  initializeScrollMagic() {
    //const controller = new ScrollMagic.Controller();
    const slidesContainer = this.el.querySelector('.super-scroll-block');
    const slide = this.el.querySelector('.super-scroll-block-slide');
    const tabs = this.el.querySelectorAll('.super-scroll-block-tab');
    let activeTabIndex = 0;
    // var isAnimation = false;
  
    addIntersectionObserver(slidesContainer as HTMLElement, () => {
      slide.classList.add('loaded');
     // slidesContainer.classList.add('animate');

      this.startSlideAutomation(tabs);
    }
    , ['.super-scroll-block']);

  
    tabs.forEach((tab, index) => {
      // const tabBar = tab.querySelector('.super-scroll-block-tab-bar');
      tab.addEventListener('click', () => {
        clearInterval(this.slideInterval); // Stop the automation on tab click
        // isAnimation = false;
        activeTabIndex = index;
        this.updateSlideContent(tabs[activeTabIndex]);
        setTimeout(() => {
          // isAnimation = true;
        }, 2000);
      });
    });
  }
  

  updateSlideContent(activeTab) {
    const block = this.el.querySelector('.super-scroll-block') as HTMLElement;
    const slide = this.el.querySelector('.super-scroll-block-slide');
    const title = activeTab.dataset.title;
    const description = activeTab.dataset.description;
    const logo = activeTab.dataset.logo;
    const logoAlt = activeTab.dataset.logoalt;
    const bgImage = activeTab.dataset.bg;
    const bgAlt = activeTab.dataset.bgalt;
    const overlayText = activeTab.dataset.text;
    const buttonsJson = activeTab.getAttribute('data-buttons');
    const buttons = buttonsJson ? JSON.parse(buttonsJson) : [];
    const tabs = this.el.querySelectorAll('.super-scroll-block-tab');
  
    const slideContent = this.el.querySelector('.super-scroll-block-slide-content');
    const cardContent = this.el.querySelector('.super-scroll-block-slide-card-content');
    const bgBlock = this.el.querySelector('.super-scroll-block-bg');
  
    // Update Background Image of the entire block to properly fade out with the overlay image with fade out
    block.style.backgroundImage = `url('${bgImage}')`;
  
    // Use the toggleFadeClass to add 'fade-out-slide' class and fade elements out
    this.toggleFade(slideContent);
    this.toggleFade(cardContent);
    this.toggleFade(bgBlock);

    setTimeout(() => {
      this.toggleFade(slideContent);
      this.toggleFade(cardContent);
      setTimeout(() => {
        this.toggleFade(bgBlock);
      }, 50);

      // Update slide content
      slide.querySelector('.super-scroll-block-slide-title').textContent = title;
      slide.querySelector('.super-scroll-block-slide-description').innerHTML = description;
      const imageBlock = slide.querySelector('image-block');
      if (imageBlock) {
          imageBlock.imageUrl = logo;
          imageBlock.imageAlt = logoAlt;
      }

      const bgBlockImage = bgBlock.querySelector('image-block');
      if (bgBlockImage) {
        // Directly set properties if they're defined on the image-block component
        bgBlockImage.imageUrl = bgImage;
        bgBlockImage.imageAlt = bgAlt || '';
      }


      // Handle button blocks
      const buttonsContainer = this.el.querySelector('.super-scroll-block-buttons');
      // Clear existing button-blocks first
      buttonsContainer.innerHTML = '';
      buttons.forEach(buttonData => {
        const buttonBlock = document.createElement('button-block');
        buttonBlock.buttonsData = buttonData;
        buttonsContainer.appendChild(buttonBlock);
      });

      slide.querySelector('.super-scroll-block-slide-card-title').textContent = overlayText;

      // Remove active class from all tabs
      tabs.forEach(tab => tab.classList.remove('scroll-active'));

      // Add active class to the current tab
      activeTab.classList.add('scroll-active');
    }, 750);
  }

  render() {
    const buttons = JSON.parse(this.buttonsData);
    const cards = JSON.parse(this.cardsData);
    // const logos = JSON.parse(this.logosData);

    return (
      <Host>
        <div class={`container super-scroll-block-wrapper relative ${this.paddingBottom} ${this.paddingTop}`}>
          <div class={`super-scroll-block ${this.backgroundColor} ${this.textColor}`} style={{ backgroundImage: `url(${cards[0].bg_image})` }}>
            <div class="super-scroll-block-top-content">
              {this.mainTitle && <h3 class="super-scroll-block-top-title">{this.mainTitle}</h3>}
              {this.mainDescription && <p class="super-scroll-block-top-description">{this.mainDescription}</p>}
            </div>
            <div class={`super-scroll-block-slides-container`}>
              {cards.length > 0 && (
                <div class="super-scroll-block-slide scroll-active">
                  <div class="super-scroll-block-slide-content flex flex-col">
                    {cards[0].title && <h3 class="super-scroll-block-slide-title">{cards[0].title}</h3>}
                    {cards[0].description && <div class="super-scroll-block-slide-description" innerHTML={cards[0].description}></div>}
                  </div>
                  <div class="super-scroll-block-slide-card">
                    <div class="super-scroll-block-slide-card-content">
                      {cards[0].logo && (
                        <div class="max-h-100px">
                          <image-block imageUrl={cards[0].logo} imageAlt={cards[0].logo_alt} imageClass="super-scroll-block-slide-card-logo"></image-block>
                        </div>
                      )}
                      {cards[0].overlay_text && <p class="super-scroll-block-slide-card-title">{cards[0].overlay_text}</p>}
                      <div class="super-scroll-block-buttons">
                        {cards[0].button.map((button, buttonIndex) => (
                          <button-block key={buttonIndex} buttonsData={button}></button-block>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div class="super-scroll-block-tabs-container">
              {cards.length > 0 &&
                cards.map(({ title, description, logo, logo_alt, overlay_text, button, bg_image, bg_alt }, index) => (
                  <div
                    class={`super-scroll-block-tab ${index === 0 ? 'scroll-active' : ''}`}
                    data-title={title}
                    data-description={description}
                    data-logo={logo}
                    data-logoalt={logo_alt}
                    data-text={overlay_text}
                    data-bg={bg_image}
                    data-bgalt={bg_alt}
                    data-buttons={JSON.stringify(button)}
                  >
                    <div class={`super-scroll-block-tab-bar`}></div>
                    <p class={`super-scroll-block-tab-bar-count mb-0 fs-min`}>{index + 1}</p>
                  </div>
                ))}
            </div>
            <div class={`super-scroll-block-bg`}>
              {cards[0].bg_image && <image-block imageUrl={cards[0].bg_image} imageAlt={cards[0].bg_alt} imageClass="super-scroll-block-background-image "></image-block>}
            </div>
            <div class="super-scroll-block-bg-overlay"></div> 
          </div>
          <div class={`super-scroll-block-bottom-buttons bottom-${this.paddingBottom}`}>
            {buttons[0].cta && buttons.length > 0 && buttons.map((button, buttonIndex) => <button-block key={buttonIndex} buttonsData={button}></button-block>)}
          </div>
        </div>
      </Host>
    );
  }
}
